<template>
    <div>
        <b-form @submit.prevent="saveRulePictogram()" data-vv-scope="formRulePictogram">
            <b-row>
                <b-col md="12">
                    <b-form-group>
                        <label>Nombre <span class="text-danger">*</span></label>
                        <b-form-input v-model="rulePictogram.name" type="text" class="form-control" name="name"
                            v-validate="'required'" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formRulePictogram.name')" />
                    </b-form-group>
                </b-col>

                <!-- Selección de SubCategorías -->
                <b-col v-if="activeGlobalVersion" cols="12">
                    <b-form-group>
                        <label>Seleccionar subcategorías <span class="text-danger">*</span></label>
                        <el-select v-validate="'required'" data-vv-as=" " v-model="sga_subcategories_ids" name="sga_subcategories_ids" placeholder="Seleccionar subcategorías" multiple clearable filterable collapse-tags collapse-tags-tooltip :max-collapse-tags="1"> 
                            <el-option-group v-for="typeOfDanger in subCategoriesByVersion" :key="typeOfDanger.name">
                                <div class="p-2 d-flex justify-content-between align-items-center w-100" :style="{ backgroundColor: typeOfDanger.color }">
                                    <div>
                                        <i class="fa fa-exclamation-triangle mr-1"></i>
                                        <strong>{{ typeOfDanger.name }}</strong>
                                    </div>
                                    <b-badge variant="light" class="text-xs font-weight-normal">
                                        {{ typeOfDanger.subCategories.length }} subcategorías disponibles
                                    </b-badge>
                                </div>
                                <el-option v-for="subcategory in typeOfDanger.subCategories" :key="subcategory.id" :label="subcategory.name" :value="subcategory.id"></el-option>
                            </el-option-group>
                        </el-select>
                        <span class="text-danger small" v-text="errors.first('formRulePictogram.sga_subcategories_ids')" />
                    </b-form-group>
                </b-col>

                <!-- Pictogramas que conforman la regla -->
                <b-col md="12">
                    <b-form-group>
                        <label>Pictogramas que conforman la regla <span class="text-danger">*</span></label>
                        <b-row class="flex-wrap ml-1">
                            <b-col class="d-flex justify-content-center" v-for="(pictogram, index) in activePictograms"
                                :key="index" cols="3" md="2" lg="2">
                                <b-img @click="togglePictogram(sga_pictogram_combinations, pictogram, false)"
                                    name="sga_pictogram_combinations" v-validate="'required'" data-vv-as=" "
                                    v-model="sga_pictogram_combinations"
                                    :class="getPictogramClass(pictogram.id, sga_pictogram_combinations, 'bg-warning')"
                                    thumbnail fluid :src="pictogram.image" :alt="pictogram.name"
                                    style="max-width: 75px; max-height: 75px; margin: 0.5rem;"></b-img>
                            </b-col>
                        </b-row>
                        <span class="text-danger small"
                            v-text="errors.first('formRulePictogram.sga_pictogram_combinations')" />
                    </b-form-group>
                </b-col>

                <!-- Pictogramas a mostrar -->
                <b-col md="12" v-if="sga_pictogram_combinations.length > 0">
                    <b-form-group>
                        <label>Pictogramas a mostrar <span class="text-danger">*</span></label>
                        <b-row class="flex-wrap ml-1">
                            <b-col class="d-flex justify-content-center"
                                v-for="(pictogram, index) in (sga_pictogram_combinations && typeof sga_pictogram_combinations === 'object') ? sga_pictogram_combinations : []" :key="index" cols="3" md="2"
                                lg="2">                                
                                <b-img @click="togglePictogram(sga_pictograms_to_display, pictogram, false)"
                                    name="sga_pictograms_to_display" v-model="sga_pictograms_to_display"
                                    v-validate="'required'" data-vv-as=" "
                                    :class="getPictogramClass(pictogram.id, sga_pictograms_to_display, 'bg-success')"
                                    thumbnail fluid :src="pictogram.image" :alt="pictogram.name"
                                    style="max-width: 75px; max-height: 75px; margin: 0.5rem;">
                                </b-img>
                            </b-col>
                        </b-row>
                        <span class="text-danger small"
                            v-text="errors.first('formRulePictogram.sga_pictograms_to_display')" />
                    </b-form-group>
                </b-col>

                <b-col md="12" class="mt-3 d-flex justify-content-end align-items-center">
                    <b-form-group>
                        <b-button variant="danger" @click="cancelRulePictogram">
                            <i class="fa fa-reply"></i>
                            <span class="ml-1" v-text="'Cancelar'"></span>
                        </b-button>
                        <b-button type="submit" variant="primary" class="mx-1">
                            <i class="fa fa-save"></i>
                            <span class="ml-1" v-text="'Guardar'"></span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
    name: 'FormRulesPictograms',

    data() {
        return {
            version_id: null,
            sga_subcategories_ids: [],
            sga_pictograms_to_display: [],
            sga_pictogram_combinations: [],
        };
    },

    computed: {
        ...mapState('sgaRulesPictograms', ['action', 'rulePictogram']),
        ...mapState('sgaPictograms', ['activePictograms']),
        ...mapState('sgaVersions', ['activeGlobalVersion']),
        ...mapState('sgaSubCategories', ['subCategoriesByVersion']),
    },

    async created() {
        await this.getActivePictogramsSga();
        this.onHandleChangeVersion(this.activeGlobalVersion);
        this.loadPictograms();
    },

    watch: {

        'rulePictogram'(next, prev) {
            if (next != prev && next && (this.action == 'edit' && this.rulePictogram)) {
                if (this.rulePictogram.version_id) this.version_id = this.rulePictogram.version_id;
            }
        },
        
        async 'sga_subcategories_ids'(next, prev) {
            if (next != prev && next && this.version_id) {   
                
                this.sga_pictogram_combinations = [];                
                if (!(Array.isArray(this.sga_subcategories_ids) && this.sga_subcategories_ids.length > 0)) {
                    return false;
                }

                await this.showSubCategoriesSga({ ids: next, callback: this.callbackShowSubCategoriesSga })        
            }
        },

        'activeGlobalVersion'(next, prev) {
            if (next != prev && next) {
                this.onHandleChangeVersion(next);
            }
        }

    },

    methods: {
        
        ...mapMutations('sgaRulesPictograms', ['setDefaultRulePictogramSga', 'setRulePictogramSga']),
        
        ...mapActions('sgaVersions', ['getActiveVersionsSga']),
        ...mapActions('sgaPictograms', ['getActivePictogramsSga']),
        ...mapActions('sgaSubCategories', ['getSubCategoriesByVersion', 'showSubCategoriesSga']),
        ...mapActions('sgaRulesPictograms', ['createRulePictogramSga', 'getRulesPictogramsSga', 'updateRulePictogramSga']),
        
        /**
         * Cambiar la versión activa.
         * 
         * @param int version 
         */
         async onHandleChangeVersion(version) {

            if (!version) {
                this.sga_subcategories_ids = [];
                this.loadPictograms()
                return
            }

            this.version_id = this.activeGlobalVersion
            
            await this.getSubCategoriesByVersion({ version_id: version, callback: this.callbackGetSubCategoriesByVersion });
        },

        callbackShowSubCategoriesSga(status, response) {
            if (!status) return;

            this.loadPictograms()

            response.map(subCategory => {
                subCategory.sga_sub_category_pictograms.map(pictogram => {
                    const pictogramData = this.activePictograms.find(p => p.id === pictogram.sga_pictogram_id);
                    if (pictogramData) {
                        this.togglePictogram(this.sga_pictogram_combinations, pictogramData, true);
                    }
                })
            })            
        },

        callbackGetSubCategoriesByVersion(isSuccess) {
            if (isSuccess) {
                if (this.rulePictogram.version_id === this.version_id) this.sga_subcategories_ids = this.rulePictogram.sga_subcategories_ids;
                else this.sga_subcategories_ids = [];
            }
        },

        cancelRulePictogram() {
            this.setDefaultRulePictogramSga();
            this.$bvModal.hide('modal_create_rulepictograms');
        },

        async cancelAndGetRulePictogram() {
            this.cancelRulePictogram();
            await this.getRulesPictogramsSga();
        },

        async saveRulePictogram() {
            const isValid = await this.$validator.validateAll('formRulePictogram');
            if (!isValid) return;

            // Enviar solo los ids de los pictogramas seleccionados
            this.rulePictogram.version_id = this.version_id;
            this.rulePictogram.sga_subcategories_ids = this.sga_subcategories_ids;
            this.rulePictogram.sga_pictogram_combination_ids = this.sga_pictogram_combinations.map(pictogram => pictogram.id);
            this.rulePictogram.sga_pictograms_to_display_ids = this.sga_pictograms_to_display
                .filter(pictogram => this.sga_pictogram_combinations.some(p => p.id === pictogram.id))
                .map(pictogram => pictogram.id);

            let flag = false;
            if (this.action === 'edit') {
                flag = await this.updateRulePictogramSga(this.rulePictogram);
            } else {
                flag = await this.createRulePictogramSga(this.rulePictogram);
            }

            if (flag) {
                this.cancelAndGetRulePictogram();
            }
        },

        togglePictogram(array, pictogram, conserveActivePictograms = false) {
            if (!Array.isArray(array)) return;

            if (array.find(p => p.id == pictogram.id)) {
                const filterArr = array.filter(p => p.id !== pictogram.id);
                if (!conserveActivePictograms) array.splice(0, array.length, ...filterArr);
            }

            else array.push(pictogram);
        },

        getPictogramClass(id, array, colorClass) {
            return array.some(p => p.id === id)
                ? `m-2 p-1 rounded border selected ${colorClass}`
                : 'm-2 p-1 rounded border pictogram';
        },

        loadPictograms() {
            this.sga_pictograms_to_display = this.activePictograms.filter(pictogram =>
                this.rulePictogram.sga_pictograms_to_display_ids.includes(pictogram.id)
            );

            this.sga_pictogram_combinations = this.activePictograms.filter(pictogram =>
                this.rulePictogram.sga_pictogram_combination_ids.includes(pictogram.id)
            );
        },
    }
}
</script>

<style scoped>
.pictogram {
    background: #eaeaea;
    opacity: 0.2;
    cursor: pointer;
}

.selected {
    opacity: 1;
    cursor: pointer;
    background: #e3ffd9;
}
</style>
